import { Box, SxProps } from "@mui/material";
import React from "react";
import theme from "Theme/AppTheme";

type TagProps = {
    text: string;
    sx?: SxProps;
};

const Tag: React.FC<TagProps> = ({ text, sx }) => {
    return (
        <Box
            sx={{
                padding: theme.spacing(1),
                color: theme.palette.primary.dark,
                background: theme.palette.primary.light,
                fontWeight: 600,
                borderRadius: 2,
                width: "fit-content",
                height: "fit-content",
                ...sx,
            }}
        >
            {text}
        </Box>
    );
};

export default Tag;
